import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../../themes'

export const CancelOrderModalStyle = styled.div`
  color: ${NATIVE_BASE_COLORS.TEXT[900]};
  padding: 32px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  .cancel-order-modal__title {
    margin: 0;
    padding: 0;
    font-size: ${FONT_SIZE.SM};
    font-family: NunitoSansBold;
  }

  .cancel-order-modal__text {
    font-size: ${FONT_SIZE.TN};
    font-family: NunitoRegular;
    margin: 0;
    padding: 0;
  }

  .cancel-order-modal__button {
    display: flex;
    gap: 16px;

    button {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-size: ${FONT_SIZE.TN};
      font-family: NunitoSansBold;
      width: 160px;
      border-radius: 4px;
      height: 40px;
      text-align: center;
      cursor: pointer;
    }

    &--back {
      border: 1px solid ${NATIVE_BASE_COLORS.MUTED[300]};
      background-color: ${COLOR.WHITE};
    }

    &--cancel {
      border: 1px solid ${COLOR.RED_3};
      background-color: ${COLOR.RED_3};
      color: ${COLOR.WHITE};
    }
  }
`
